import React from 'react'
import parse from 'html-react-parser'
import clsx from 'clsx'
import { useNode } from '@craftjs/core'

import { Text as LibraryText } from '@wartek-id/text'

import type { IText as TextInterface } from './typings'

const Text = ({ text }: TextInterface) => {
  const {
    connectors: { connect, drag },
    isSelected,
  } = useNode((node) => ({
    isSelected: node.events.selected,
  }))

  const renderedText = parse(text)

  return (
    <LibraryText
      // @ts-expect-error
      ref={(ref) => connect(drag(ref!))}
      className={clsx(
        'simple-wysiwyg-content',
        'widget-component mb-2 last:mb-0',
        'text-black',
        isSelected && 'widget-component__selected'
      )}
      variant="body"
      as="div"
    >
      {renderedText}
    </LibraryText>
  )
}

export default Text
